<form [formGroup]="form">
  <ion-row>
    <ion-col size="12" class="container">
      <ion-radio-group
        class="revenue-config-radio-group"
        formControlName="revRecoveryType"
      >
        <ion-radio
          class="radio-btn"
          [labelPlacement]="'end'"
          [value]="TYPE.PACKAGE"
        >
          {{ CONSTANTS.PACKAGE }}
        </ion-radio>
        <ion-radio
          class="radio-btn"
          [labelPlacement]="'end'"
          [value]="TYPE.PALLET"
        >
          {{ CONSTANTS.PALLET }}
        </ion-radio>
      </ion-radio-group>
    </ion-col>
  </ion-row>
  @if (form.get("revRecoveryType")?.value === TYPE.PACKAGE) {
    <app-package-setting
      [form]="getPackageForm"
      [unit]="unit"
    ></app-package-setting>
  }
  @if (form.get("revRecoveryType")?.value === TYPE.PALLET) {
    <app-pallet-setting
      [form]="getPalletForm"
      [unit]="unit"
    ></app-pallet-setting>
  }
</form>
